var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instashare-buy-now__timer-wrap"},[_c('div',{staticClass:"instashare-buy-now__timer-lead-in"},[_vm._v("Offer ends in:")]),_vm._v(" "),_c('div',{staticClass:"instashare-buy-now__timer-time"},[_vm._v(_vm._s(_vm.countdown))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af3dd4da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/proofs/index/components/InstashareTimer.vue
// module id = 705
// module chunks = 1